// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@werner/XDL/types";
import color from "@werner/XDL/Utilities/color";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            size: 14,
            color: "text.main",
            ellipsis: true,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
                max-width: 100ch;
            `,
        },
        css: css`
            flex-wrap: wrap;
            ${StyledButton} {
                position: relative;
                overflow: hidden;
            }
            ${StyledButton} > ${TypographyStyle} {
                color: ${color("primary")};
            }

            ${StyledButton}:hover > ${TypographyStyle} {
                color: ${color("primary")};
                text-decoration: underline;
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
